import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { QuestionSetLabel } from '../../shared/models/question-set-label';
import { QuestionSet } from '../../shared/models/question-set';

import { AssessmentService } from '../../shared/services/assessment.service';
import { Assessment } from '../../shared/models/assessment';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'app-label-edit',
  templateUrl: './label-edit.component.html',
  styleUrls: ['./label-edit.component.css']
})
export class LabelEditComponent implements OnInit {

  private _label:QuestionSetLabel;
  private questionSet:QuestionSet;
  private assessment:Assessment;
  public isSaving:boolean;

constructor( private assessmentService:AssessmentService
    ,private alertService: AlertService
    ,private location:Location
    ,private router: Router
    ,private route: ActivatedRoute) { 
      this.label = this.getNewObject();
    }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      let setId = params['setId'];
      let labelId = params['labelId'];
      this.assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this.assessment = assessment;
          this.questionSet = assessment.question_sets.find((s) => s.id == setId);
        this.label = (this.questionSet) ? this.questionSet.labels.find((l) => l.id == labelId) : null;
        console.log(this.label);
          if (!(this.questionSet && this.label)) {
            // TODO: stephen should we navigate back?? or do some kind of 404?
            this.router.navigate(["not-found"]);
          }
        })
        .catch((error) => {
          console.error(error);
          this.router.navigate(["not-found"]);
        })
    });
  }

  private getNewObject() {
    let label = new QuestionSetLabel();
    return label;
  }

  get label():QuestionSetLabel {
    return this._label;
  }

  set label(v:QuestionSetLabel) {
    this._label = v;
  }

  goBack() {
    this.location.back();
  }

  private saveLabel(label) {
    this.isSaving = true;
		return this.assessmentService.saveAssessment(this.assessment).then((assessment) => {
      this.alertService.success("Label saved");
      this.isSaving = false;
      return label;
    }).catch((error) => {
      this.isSaving = false;
      this.alertService.error("An error occurred in saving. Please try again or contact support.");
			console.error(error);
		});
  }

  save() {
    this.saveLabel(this.label);
	}
	
	saveAndCreateNew() {
    this.saveLabel(this.label).then((question) => {
      this.router.navigate(["../../", "new"], {replaceUrl: true, relativeTo: this.route});
    });
	}

}



// WEBPACK FOOTER //
// ./src/app/admin/label-edit/label-edit.component.ts